// tslint:disable:max-line-length

import React from 'react';

export const ArrowChevronLeftSmall = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M8.9,3L5.6,7.1L4.9,8l0.8,0.9L8.9,13h2.2l-0.1-0.1L7.1,8l4.1-5H8.9L8.9,3z" />
    </svg>
  );
};
